import React from 'react';
import {ColorPicker, Popover, FormLayout, Button, TextField} from '@shopify/polaris';

export default class AdvancedColorPicker extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      popoverActive: false,
      color: { hue: 120, brightness: 1, saturation: 1, },
      hexColor: props.color,
      originalColor: props.color
    }
  }

  componentWillReceiveProps(newProps) {
    if(newProps.color != "" && newProps.color != null && newProps.color != undefined) {
      this.hexToHsl(newProps.color);
      this.setState({
        originalColor: newProps.color,
      })
    }
  }

  onPopoverToggle() {
    var popoverActive = this.state.popoverActive;
    if(popoverActive) {
      this.onPopoverClose();
    } else {
      this.setState({
        popoverActive: true
      })
    }
  }

  onPopoverClose() {
    this.setState({
      originalColor: this.state.hexColor,
      popoverActive: false
    })
    this.props.onColorSelect(this.state.hexColor);
  }

  onColorChange(color) {
    var h = color['hue'];
    var s = color['saturation'];
    var v = color['brightness'];
    var colorString = this.hslToHex(h, s, v)
    this.setState({
      color: color,
      hexColor: colorString
    })
  }

  onChange(text) {
    this.props.onChange(text)
  }

  hslToHex(h, s, v) {
    var r, g, b, i, f, p, q, t;
    if (arguments.length === 1) {
        s = h.s, v = h.v, h = h.h;
    }
    h /= 360;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0: r = v, g = t, b = p; break;
        case 1: r = q, g = v, b = p; break;
        case 2: r = p, g = v, b = t; break;
        case 3: r = p, g = q, b = v; break;
        case 4: r = t, g = p, b = v; break;
        case 5: r = v, g = p, b = q; break;
    }
    const toHex = x => {
      const hex = Math.round(x * 255).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  hexToHsl(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if(result == null) {
      this.setState({
        hexColor: hex
      })
      return;
    }

    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);

    r /= 255, g /= 255, b /= 255;

    var max = Math.max(r, g, b), min = Math.min(r, g, b),
        d = max - min,
        h,
        s = (max === 0 ? 0 : d / max),
        v = max;

    switch (max) {
        case min: h = 0; break;
        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
        case g: h = (b - r) + d * 2; h /= 6 * d; break;
        case b: h = (r - g) + d * 4; h /= 6 * d; break;
    }

    this.setState({
      color: {hue: (h*360), saturation: s, brightness: v},
      hexColor: hex
    })
  }

  render() {
    return(
      <div>
        <TextField key={this.props.fieldKey} label={this.props.label} name={this.props.name} maxLength="7" placeholder="#123456" value={this.state.hexColor} onChange={this.onChange.bind(this)} connectedRight={
          <Popover
            active={this.state.popoverActive}
            sectioned
            activator={
              <div className="color-activator-box" onClick={this.onPopoverToggle.bind(this)} style={{background: this.state.hexColor}}>
              </div>
            }
            onClose={this.onPopoverClose.bind(this)}>
            <FormLayout>
              <ColorPicker color={this.state.color} onChange={this.onColorChange.bind(this)} />
              <div className="color-compare-box">
                <div className="color-before" style={{backgroundColor: this.state.originalColor}} > </div>
                <div className="color-after" style={{backgroundColor: this.state.hexColor}} > </div>
              </div>
              <TextField value={this.state.hexColor} onChange={this.hexToHsl.bind(this)}/>
            </FormLayout>
          </Popover>
        } />
      </div>
    )
  }
}
